<template>
  <div class="badges-wrapper">
    <div
      v-for="(badge, key) in allBadges"
      :key="key"
      v-tooltip="badge[1].description.organisation"
      class="badge"
      @click="selectBadge(badge)"
    >
      <img width="100px" :src="props.selectedBadges[badge[0]] ? badge[1].img : badge[1]['img-grey']" :alt="badge[1].title" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.badges-wrapper {
  flex-grow: 1;
  flex-basis: 0;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  overflow-y: auto;
  align-content: flex-start;

  &::-webkit-scrollbar {
    padding-left: 4px;
    width: 3px;
    border-radius: 24px;
    background-color: var(--light-grey-color);
  }

  &::-webkit-scrollbar-thumb {
    background: $primary-color;
    padding: 4px;
    width: 3px;
    border-radius: 24px;
  }

  .badge {
    display: flex;
    gap: 24px;
    border-radius: 4px;

    &.selected {
      background-color: $primary-100-color;
    }

    &:hover {
      background-color: var(--light-grey-color);
    }

    img {
      height: 100%;
    }

    .text {
      flex: 8;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .title {
        font-size: 18px;
        font-weight: 600;
      }

      .description {
        font-size: 16px;
      }
    }
  }
}
</style>

<script setup lang="ts">
import { computed } from "vue";
import i18n from '@/i18n';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n({ useScope: 'global' });

export interface SelectedBadges {
  [id: string]: Boolean,
}

const emits = defineEmits(['updateSelected'])

const props = defineProps<{
  selectedBadges?: SelectedBadges,
}>();

function selectBadge(badge) {
  const newSelectedBadges = {...props.selectedBadges};

  newSelectedBadges[badge[0]] = !newSelectedBadges[badge[0]];
  emits('updateSelected', newSelectedBadges);
}

const allBadges = computed(() => {
  const localeData = i18n.global.messages.value[locale.value];
  const badgeLocales = Object.entries(localeData.badges);
  return badgeLocales;
});

</script>